<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>AG Charts</h1>
					<p waBody="m" waText>Enterprise charting &#40;AG Charts 13.1.0&#41; &mdash; 38 chart types with CRTP fluent API, reactive data binding, server-side configuration, and full TypeScript generation for Angular 21. Covers line, bar, area, scatter, bubble, pie, donut, histogram, and all cartesian/polar variants.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">AG Charts 13.1.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:agcharts</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.agcharts</p>
					<p waBody="s" waText>Built on: AG Charts 13.1.0</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_49" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_50" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>NPM DEPENDENCIES &#40;auto-included&#41;</div>
					<markdown [data]="mdContent_51" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Complete AG Charts 13.1.0 API &mdash; all 38 official chart options implemented with type-safe Java models</p>
					<p waBody="s" waColorText="quiet" waText>CRTP fluent builders &mdash; type-safe, self-referencing setters for intuitive chart configuration</p>
					<p waBody="s" waColorText="quiet" waText>Multiple chart types &mdash; Line, Bar, Area, Scatter, Bubble, Pie, Donut, Histogram, and more</p>
					<p waBody="s" waColorText="quiet" waText>Advanced axes &mdash; Number, Time, Log, Category, Grouped Category, Ordinal Time</p>
					<p waBody="s" waColorText="quiet" waText>Rich interactions &mdash; tooltips, legends, zoom, pan, highlighting, animations, context menus</p>
					<p waBody="s" waColorText="quiet" waText>Theming support &mdash; Material, Polychrome, Vivid, Solar built-in themes plus custom theme API</p>
					<p waBody="s" waColorText="quiet" waText>Gradient legends for heatmaps and continuous color scales</p>
					<p waBody="s" waColorText="quiet" waText>Navigator component &mdash; mini-chart navigator for large datasets with zoom controls</p>
					<p waBody="s" waColorText="quiet" waText>Overlays and annotations &mdash; custom overlays, chart annotations, and watermarks</p>
					<p waBody="s" waColorText="quiet" waText>Reactive data binding &mdash; real-time chart updates via Angular observables</p>
					<p waBody="s" waColorText="quiet" waText>TypeScript type generation &mdash; automatic from Java models</p>
					<p waBody="s" waColorText="quiet" waText>Server-side configuration &mdash; define charts in Java, render client-side</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Line Chart</h4>
						<p waBody="s" waColorText="quiet" waText>Create a line chart with axes and series.</p>
						<markdown [data]="mdContent_52" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Pie Chart</h4>
						<p waBody="s" waColorText="quiet" waText>Create a pie chart with themed colors.</p>
						<markdown [data]="mdContent_53" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_54" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IPageConfigurator</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>AgChartsPageConfigurator auto-registers ag-charts-community and Angular integration</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://charts.ag-grid.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://charts.ag-grid.com/javascript/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/AgCharts</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>